import api from './api';

const contentService = {
  // Get all pages
  getPages: (params = {}) => {
    return api.get('/api/content-pages', { params });
  },

  // Get single page by ID
  getPage: (id) => {
    return api.get(`/api/content-pages/${id}`);
  },

  // Get page by slug - extra endpoint
  getPageBySlug: (slug) => {
    return api.get(`/api/content-pages/slug/${slug}`);
  },

  // Create page
  createPage: (data) => {
    return api.post('/api/content-pages', data);
  },

  // Update page
  updatePage: (id, data) => {
    return api.put(`/api/content-pages/${id}`, data);
  },

  // Delete page
  deletePage: (id) => {
    return api.delete(`/api/content-pages/${id}`);
  },

  // Publish page - backend bonus endpoint
  publishPage: (id) => {
    return api.post(`/api/content-pages/${id}/publish`);
  },

  // Unpublish page - backend bonus endpoint
  unpublishPage: (id) => {
    return api.post(`/api/content-pages/${id}/unpublish`);
  },

  // Get published pages only - backend bonus endpoint
  getPublishedPages: (params = {}) => {
    return api.get('/api/content-pages/published', { params });
  },

  // Get page templates - not implemented yet in backend
  getTemplates: () => {
    return api.get('/api/content-pages/templates');
  },

  // Duplicate page - not implemented yet in backend
  duplicatePage: (id) => {
    return api.post(`/api/content-pages/${id}/duplicate`);
  },
};

export default contentService;
